import { getRequest, postRequest } from '../request/request.service';
import {
  SharedVoicesParams,
  SharedVoicesResponse,
  VoicesParams,
  VoicesResponse,
} from './voices.service.types';

const AGENTS_URL = 'conversational_agents';

export function getVoices(params: VoicesParams) {
  return getRequest<VoicesResponse>(`/${AGENTS_URL}/voices`, { params });
}

export function getSharedVoices(params: SharedVoicesParams) {
  return getRequest<SharedVoicesResponse>(`/${AGENTS_URL}/shared_voices`, {
    params,
  });
}

export function addSharedVoice(data: { company_id: number; public_user_id: string; voice_id: string; new_name: string }) {
  return postRequest<{ voice_id: string }>(`/${AGENTS_URL}/add_shared_voice`, { data });
}
